import { render } from "./AnglesList.vue?vue&type=template&id=01e834b2"
import script from "./AnglesList.vue?vue&type=script&lang=js"
export * from "./AnglesList.vue?vue&type=script&lang=js"
script.render = render

export default script